import { render, staticRenderFns } from "./jbdate.vue?vue&type=template&id=4bc346b9"
import script from "./jbdate.vue?vue&type=script&lang=js"
export * from "./jbdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports